var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollegeGradCap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3n-web/art/college-grad-cap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3n-web/art/college-grad-cap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "art/college-grad-cap-copy-2",
    transform: "translate(5, 19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37107811,44.5540961 C9.54846149,42.4290338 10.2761882,40.725359 11.131267,40.08195 C9.80316583,39.7557144 8.81163823,38.5640483 8.81163823,37.1367676 C8.81163823,35.7502663 9.74858633,34.5812555 11.022108,34.2187715 L11.022108,17.8254332 L12.6958794,17.1865552 L12.6958794,34.2187715 C13.9694011,34.5812555 14.9063492,35.7502663 14.9063492,37.1367676 C14.9063492,38.5640483 13.9193699,39.7557144 12.5867204,40.08195 C13.4463475,40.725359 14.1695259,42.4290338 14.3469093,44.5540961 C14.778997,50.6981997 15.2110847,56.8377722 15.6431724,62.9818758 C15.6067861,62.9864069 15.5703998,62.9909379 15.5340134,63 C14.5106478,62.1209763 13.2371261,61.5953746 11.8544454,61.5953746 C10.4717647,61.5953746 9.19824302,62.1209763 8.17487738,63 C8.13849105,62.995469 8.10210471,62.9909379 8.06571838,62.9818758 C8.4978061,56.8377722 8.92989381,50.6981997 9.36198153,44.5540961 L9.37107811,44.5540961 Z",
    id: "Path",
    fill: "#F6C760",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3364486,18.48 C68.6379945,13.1252379 57.6096064,9.24 44.5794393,9.24 C31.5492721,9.24 20.520884,13.1252379 16.8224299,18.48 C22.9654356,15.00087 33.1045576,12.7233167 44.5794393,12.7233167 C56.0543209,12.7233167 66.1934429,15.00087 72.3364486,18.48 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7140263,37.7959113 L72.7140263,25.7179016 L90,18.5790373 L45,0 L0,18.583126 L17.2859737,25.7219903 L17.2859737,37.0640346 C24.8943284,34.2510114 34.1150004,32.6073553 44.0563857,32.6073553 C54.8336498,32.6073553 64.7676051,34.5453975 72.7140263,37.8 L72.7140263,37.7959113 Z M45,14.7888156 C58.0099893,14.7888156 69.0250144,18.583126 72.7140263,23.812569 C66.5805333,20.4148621 56.4571122,18.1906111 45,18.1906111 C33.5428878,18.1906111 23.4194667,20.4148621 17.2859737,23.812569 C20.9787006,18.583126 31.9900107,14.7888156 45,14.7888156 Z",
    id: "Shape",
    fill: "#1B7690",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollegeGradCap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/college-grad-cap.34377c8eeb8099571879c323bfc311ce.svg";